import { UserManager } from '@rozetta/oidc-client'
export const login = {
  methods: {
    login: function (iid) {
      if (this.user !== null) {
        // 既にログイン済み
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            // message: 既にログイン済みです。
            eid: "E152111:00000000",
            param: {
              user: this.user.name ? this.user.name : this.user.user
            }
          }
        });
        return;
      }
      if (!this.idps[iid]) {
        if (this.$store.getters.debug) {
          console.error("Error: idp not found." + iid);
        }
        this.$store.commit("setNotification", {
          type: "error",
          message: {
            // message: ログインエラー。
            eid: "E152312:00000001",
            param: {}
          }
        });
        return;
      }
      var idp_config = this.idps[iid];
      if (this.$store.getters.debug) {
        console.log(idp_config);
      }
      var top_url = window.location.protocol + "//" + window.location.host + "/v" + this.$store.getters.api_version + "/";
      idp_config["config"]["redirect_uri"] = top_url + "auth/callback";
      idp_config["config"]["post_logout_redirect_uri"] = top_url;
      idp_config["config"]["silent_redirect_uri"] = top_url + "auth/renew.html";
      idp_config["config"]["automaticSilentRenew"] = false;
      // automaticSilentRenewはaddAccessTokenExpiringで手動実施する → 更新後のuserを確実に取得するため
      try{
        localStorage.setItem(this.$store.getters.domain + "_idp_config", JSON.stringify(idp_config));
      }catch(e){
        // エラールート
        if(this.$store.getters.debug){
          console.error("setItem idp_config:" + e);
        }
        this.$store.commit("setNotification", {
          type: "warning",
          message: {
            eid: "E1" + this.module_id + "106" + ":00000004",
            param: {}
          }
        });
        return;
      }
      var um = new UserManager(idp_config["config"]);
      // コンストラクタエラーは発生しない模様
      // renewの設定
      this.set_renew(um);
      // signinRedirect
      um.signinRedirect()
        .catch(function (error) {
          if (this.$store.getters.debug) {
            console.error("signinRedirect:" + error);
          }
          this.$store.commit("setNotification", {
            type: "error",
            message: {
              // message: ログインエラー。
              eid: "E152312:00000002",
              param: {}
            }
          });
          if (this.$route.path !== "/") {
            this.$router.push("/");
          }
          this.reset_auth();
        });
      this.$store.commit("setAuth", um);
      try{
        for(var key in localStorage){
          if(key.startsWith("oidc.")){
              localStorage.removeItem(key);
          }
        }
      }catch(e){
        // エラールート
        if(this.$store.getters.debug){
          console.error("removeItem oidc.*:" + e);
        }
      }
    },
    set_renew: function (um) {
      if (this.$store.getters.debug) {
        um.events.addUserLoaded(function () {
          console.log("UserManager: userLoaded");
        })
        um.events.addUserUnloaded(function () {
          console.log("UserManager: userUnloaded");
        })
        um.events.addAccessTokenExpired(function () {
          console.log("UserManager: accessTokenExpired");
        })
        um.events.addSilentRenewError(function () {
          console.log("UserManager: silentRenewError");
        })
        um.events.addUserSignedOut(function () {
          console.log("UserManager: userSignedOut ");
        })
      }
      um.events.addAccessTokenExpiring(function () {
        if (this.$store.getters.debug) {
          console.log("UserManager: accessTokenExpiring");
        }
        // TokenExpire前にsigninSilentする
        this.$store.getters.auth.signinSilent()
          .then(user => {
            if (user) {
              if (this.$store.getters.debug) {
                console.log("setAccessToken(signinSilent)");
                this.$store.commit("setNotification", {
                  type: "debug",
                  "message": "auth renew"
                });
              }
              if(this.$store.getters.session_state !== user.session_state){
                this.$store.commit("setNotification", {
                  type: "warning",
                  message: {
                    // message: 別のユーザがログイン中です。
                    eid: "E152315:00000000",
                    param: {}
                  }
                });
                if (this.$route.path !== "/") {
                  this.$router.push("/");
                }
                this.reset_auth();
              }
              this.$store.commit("setAccessToken", user.access_token);
              this.$store.commit("setSessionState", user.session_state);
            }
          })
          .catch(error => {
            if (this.$store.getters.debug) {
              console.error("signinSilent:" + error);
            }
            this.$store.commit("setNotification", {
              type: "error",
              message: {
                // message: ログインエラー。
                eid: "E152312:00000004",
                param: {}
              }
            });
            if (this.$route.path !== "/") {
              this.$router.push("/");
            }
            this.reset_auth();
          });
      }.bind(this));
    },
    reset_auth: function(){
      var um = this.$store.getters.auth;
      if(um !== null){
        um.removeUser();
      }
      this.$store.commit("setUser", null);
      this.$store.commit("setAccessToken", null);
      this.$store.commit("setSessionState", null);
      this.$store.commit("setAuth", null);
      try{
        localStorage.removeItem(this.$store.getters.domain + "_idp_config");
      }catch(e){
        // エラールート
        if(this.$store.getters.debug){
          console.error("removeItem idp_config:" + e);
        }
      }
    },
    get_profile: function(){
      this.$http.get(this.$store.getters.api_endpoint + "/profile")
        .then(response => {
          if(response && "data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            this.$store.commit("setUser", response.data);
            this.$emit("login", response.data);
          }
        })
        .catch(error =>{
          // エラールート
          if(this.$store.getters.debug){
            console.error("get_profile:" + error);
          }
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
            var um = this.$store.getters.auth;
            if(um !== null){
              // 3秒後にIdPからもログアウト
              window.setTimeout(function(){
                this.signoutRedirect();
              }.bind(um), 3000)
            }
          }
          this.reset_auth();
        });
    }
  }
}
